import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { NotificationService } from '@clean-code/notifications/domain';
import { SplashScreenService } from '@clean-code/shared/common';
import { RegisterUserLimitViolationNotificationType } from '@clean-code/user-limit/ui-violation-notification';
import { interval } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from '../environments/environment';

@Component({
  selector: 'clean-code-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [CommonModule, RouterModule],
})
export class AppComponent implements OnInit {
  title = 'frontoffice';

  private splashState = inject(SplashScreenService);
  public showSplash$ = this.splashState.showSplash$;

  titleService = inject(Title);
  private http = inject(HttpClient);

  constructor() {
    this.titleService.setTitle(environment.name);

    const notificationService = inject(NotificationService);
    RegisterUserLimitViolationNotificationType(notificationService);
  }

  ngOnInit() {
    // Check version every 5 minutes
    interval(5 * 60 * 1000)
      .pipe(switchMap(() => this.http.get('/version.json')))
      .subscribe((newVersion: any) => {
        const currentVersion = localStorage.getItem('appVersion');
        if (currentVersion && currentVersion !== newVersion.version) {
          // Version changed, reload the app
          window.location.reload();
        }
        localStorage.setItem('appVersion', newVersion.version);
      });
  }
}
